import React from 'react'

import './ToggleSwitch.sass'

interface ToggleSwitchProps {
  value: boolean
  onChange?: (newValue: boolean) => void
  disabled?: boolean
}

const ToggleSwitch = ({ value, onChange, disabled }: ToggleSwitchProps) => {
  const handleChange = () => {
    if (onChange) {
      onChange(!value)
    }
  }
  return (
    <div className={`switcher ${value ? 'right' : 'left'}${disabled ? ' disabled' : ''}`}>
      <div className="toggle" onClick={handleChange} />
    </div>
  )
}

export default ToggleSwitch
